export default __webpack_public_path__ + "static/documents-system-2-afc8271dde77e9cbd89e293c6c62bef5.png";